import palette from '~/theme/dark/palette'

export default {
  styleOverrides: {
    indicator: {
      backgroundColor: palette.text.primary
    }
  }
}
